import React from 'react';
import { CTAButton } from './CTAButton';
export function PreviewSection() {
  return <section className="bg-primary py-10 md:py-24 px-4 border-y border-border" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-157">
          <div className="md:w-1/2 flex justify-center" data-id="element-158">
            <div className="relative" data-id="element-159">
              <div className="absolute inset-0 bg-trust/10 rounded-full blur-2xl transform scale-110 -z-10" data-id="element-160"></div>
              <img src="https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png" alt="Vista previa de la guía" className="w-full max-w-[260px] md:max-w-[350px] h-auto object-contain drop-shadow-xl" data-id="element-161" />
            </div>
          </div>

          <div className="md:w-1/2 text-center md:text-left" data-id="element-162">
            <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-4 md:mb-6" data-id="element-163">
              Diseñada para mamás ocupadas
            </h2>
            <p className="text-base md:text-lg text-text-secondary mb-5 md:mb-6 leading-relaxed" data-id="element-164">
              Sabemos que no tienes tiempo para leer un manual de 300 páginas.
              Esta guía va directo al grano.
            </p>
            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8 text-left inline-block md:block" data-id="element-165">
              <li className="flex items-center gap-3 text-text-primary font-medium text-sm md:text-base" data-id="element-166">
                <span className="w-2 h-2 rounded-full bg-coral flex-shrink-0" data-id="element-167"></span>
                Lectura rápida y digerible (aprox. 45 minutos)
              </li>
              <li className="flex items-center gap-3 text-text-primary font-medium text-sm md:text-base" data-id="element-168">
                <span className="w-2 h-2 rounded-full bg-coral flex-shrink-0" data-id="element-169"></span>
                Formato PDF compatible con cualquier celular o tablet
              </li>
              <li className="flex items-center gap-3 text-text-primary font-medium text-sm md:text-base" data-id="element-170">
                <span className="w-2 h-2 rounded-full bg-coral flex-shrink-0" data-id="element-171"></span>
                Ejercicios prácticos al final de cada capítulo
              </li>
              <li className="flex items-center gap-3 text-text-primary font-medium text-sm md:text-base" data-id="element-172">
                <span className="w-2 h-2 rounded-full bg-coral flex-shrink-0" data-id="element-173"></span>
                Lenguaje claro, sin jerga psicológica complicada
              </li>
            </ul>

            <div className="flex justify-center md:justify-start" data-id="element-174">
              <CTAButton data-id="element-175" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}